  const tabs = document.querySelectorAll(".payment_subtitle");
  const leftArrow = document.querySelector(".payment_options_container .chevron-left-btn");
  const rightArrow = document.querySelector(".payment_options_container .chevron-right-btn");
  const productOriginalPrice = document.getElementById("productPrice");
  function selectedBank(button,activeTab) {
    setTimeout(() => {
      let price = Math.floor(
            (variantInput?.currentVariant?.price 
            ?? document.querySelector('.price')?.dataset.price 
            ?? productOriginalPrice.getAttribute("data-product-price")) / 100); 
      const installment_periods = button.dataset.period.split(",").map(Number);
      const activeInstallment = document.querySelector(activeTab).querySelector('.installments-info.active');
      const discountData = offer_percentage_calculaion(price,button.dataset.offer)

      installment_periods.forEach((period) => {
        const total_interest = price * (button.dataset.interest / 100) * period;
        const adminfee = price * (button.dataset.adminfee/100);        
        let first_month;
        if (discountData[period]) {
          const { discountAmount } = discountData[period];
          const formula = ((price - discountAmount) + total_interest) / period;
          first_month = formula - discountAmount + adminfee;
        } else {
          first_month = ((price + total_interest) / period) + adminfee;          
        }
        if (activeInstallment) {
          const element = activeInstallment.querySelector(`.installments-info-${period}-months-text`);
          if (element) {
              element.innerText = `${convertToRupiah(first_month, false)}`;
          }
        }
      });
      installment_periods.forEach((period) => {
        if (discountData[period]) {
          const { discountPercentage } = discountData[period];
          const total_interest = price * (button.dataset.interest / 100) * period;
          const adminfee = price * (button.dataset.adminfee/100);        
          const finalPrice = ((price + total_interest) / period) + adminfee;

          const originalPriceElement = activeInstallment.querySelector(`.original_price_${period}`);
          const offerElement = activeInstallment.querySelector(`.offer_installment_${period}`);
          if (offerElement) {
            originalPriceElement.innerText = `${convertToRupiah(finalPrice, false)}/bulan`;
            offerElement.innerText = `${discountPercentage}% off`;
          }
        }
      });
    }, 0); 
  }

  function offer_percentage_calculaion(price,offer) {
    const offers = offer.split(","); 
    const discountData = {}; 
    offers.forEach((offer) => {
      const [months, discount] = offer.split(":").map(Number);
      const discountAmount = (discount / 100) * price;
      const finalPrice = price - discountAmount;
      discountData[months] = { discountPercentage: discount, discountAmount: discountAmount, finalPrice: finalPrice,};
    });
    return discountData;
  }

  function selectPaymentOption(element) {
    element.scrollIntoView({ behavior: "smooth", inline: "center" }); 
    document.querySelectorAll('.payment_subtitle').forEach(item => { item.classList.remove('active'); });
    element.classList.add('active');
    updateInstallmentRow(element);
    updateArrowVisibility(); 
  }
  
  function updateArrowVisibility() {
    const wrapper = document.querySelector('.payment_tabs_wrapper');
    if (!wrapper) return;
    const scrollLeft = wrapper.scrollLeft;
    const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
    if (scrollLeft <= 0) {
        leftArrow.style.display = "none";
        rightArrow.style.display = "block";
    } else if (scrollLeft >= maxScrollLeft - 1) {
        leftArrow.style.display = "block";
        rightArrow.style.display = "none";
    } else {
        leftArrow.style.display = "block";
        rightArrow.style.display = "block";
    }
  }

  document.querySelector('.payment_tabs_wrapper').addEventListener('scroll', updateArrowVisibility); 

  const firstTab = document.querySelector(".payment_subtitle");
  if (firstTab) {
    firstTab.classList.add("active");
  }

  function updateArrows() {
    const activeTab = document.querySelector(".payment_subtitle.active");
    const activeIndex = Array.from(tabs).indexOf(activeTab);
    leftArrow.style.display = activeIndex === 0 ? "none" : "block";
    rightArrow.style.display = activeIndex === tabs.length - 1 ? "none" : "block";
  }

  function updateInstallmentRow(currentActiveTab) {
    document.querySelectorAll('.installments-row').forEach(item => {
      item.style.display = 'none';
    });
    const installmentRow = document.querySelector('.installments-row.' + currentActiveTab.dataset.option);
    installmentRow ? installmentRow.style.display = 'block' : installmentRow.style.display = 'none'
    document.querySelectorAll('.installments-item-container, .installments-info').forEach(item => {
      item.classList.remove('active');
    });
  }

  function selectPaymentTab(tab) {
    tabs.forEach((t) => t.classList.remove("active"));
    tab.classList.add("active");
    tab.scrollIntoView({ behavior: "smooth", inline: "center" });
    updateArrows();
  }

  leftArrow.addEventListener("click", function () {
    const activeTab = document.querySelector(".payment_subtitle.active");
    const activeIndex = Array.from(tabs).indexOf(activeTab);
    const currentActiveTab = tabs[activeIndex - 1];
    updateInstallmentRow(currentActiveTab)
    if (activeIndex > 0) {
      selectPaymentTab(tabs[activeIndex - 1]);
    }
  });

  rightArrow.addEventListener("click", function () {
    const activeTab = document.querySelector(".payment_subtitle.active");
    const activeIndex = Array.from(tabs).indexOf(activeTab);
    const currentActiveTab = tabs[activeIndex + 1];
    updateInstallmentRow(currentActiveTab)

    if (activeIndex < tabs.length - 1) {
      selectPaymentTab(tabs[activeIndex + 1]);
    }
  });

  if (!document.querySelector(".payment_subtitle.active") && tabs.length) {
    tabs[0].classList.add("active");
  }
  
  updateArrows(); 